export type CreateCompanyByPublic = {
  name: string
  email: string
  phone: string
  password: string
  confirmPassword: string
  companyName: string
  fantasyName: string
  cnpj: string
  companyEmail: string
  companyPhone: string
  companyCep: string
  companyStreet: string
  companyNumber: string
  companyDistrict: string
  companyComplement: string
  companyUf: string
  companyCity: string
}

export type CompanyUser = {
  companyId: number
  companies: number[]
  name: string
  email: string
  phone: string
  registration?: string
  password: string
  confirmPassword: string
  fullAccess: boolean
  sendWelcomeEmail?: boolean
  groups?: number[]
}

export type CompanyUserChangePassword = {
  password: string
  confirmPassword: string
}

export type CompanyDoctorInvite = {
  companyIds: number[]
  crm: string
  crmUf: string
  autoApprove: boolean
}

export enum CompanyDoctorInviteStatusEnum {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED'
}

export type CompanyDoctorInviteSearchParams = {
  search?: string
  inviteStatus?: CompanyDoctorInviteStatusEnum | CompanyDoctorInviteStatusEnum[]
  names?: string
  crms?: string
  crmUFs?: string
  companies?: string
  limit?: number
  offset?: number
  sortBy?: 'name' | 'crmName' | 'crmNumber'
  order?: OrderEnumEdit.ASC
}
export enum OrderEnumEdit {
  ASC = 'ASC',
  DESC = 'DESC'
}

export interface UpdateUserPayload {
  name?: string
  phone?: string
  registration?: string
  fullAccess?: boolean
  companies?: number[]
}
